import { https } from '../http';

const formatRetryAfter = (seconds) => {
  if (!seconds) return '';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const minPart = mins > 0 ? `${mins} ${mins === 1 ? 'minute' : 'minutes'}` : '';
  const secPart = secs > 0 ? `${secs} ${secs === 1 ? 'second' : 'seconds'}` : '';
  return [minPart, secPart].filter(Boolean).join(' ');
};

export const bookDemo = async (quizData) => {
  try {
    const res = await https().post('/auth/book-demo', quizData);
    return res.data;
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;
    if (status === 429) {
      if (data?.limitType === 'daily') {
        throw new Error('You have reached the daily submission limit. Please try again tomorrow.');
      }
      if (data?.retryAfter) {
        throw new Error(`Please wait ${formatRetryAfter(data.retryAfter)} before submitting again.`);
      }
      throw new Error('Too many submissions. Please try again later.');
    }
    throw new Error(data?.message || 'Something went wrong. Please try again.');
  }
};
